/**
 * Convert a GeoJSON {@link Point}, {@link Feature} point or {@link Position} into a {@link LatLng}
 * @param point - the point to convert
 */
export function pointToLatlng(point) {
    if (Array.isArray(point)) {
        return point.toReversed();
    }
    else if (point.type === 'Point') {
        return point.coordinates.toReversed();
    }
    else {
        return point.geometry.coordinates.toReversed();
    }
}
/**
 * Convert a {@link LatLng} into a GeoJSON {@link Point}
 * @param latlng - the latlng to convert
 */
export function latlngToPoint(latlng) {
    return { type: 'Point', coordinates: latlng.toReversed() };
}
/**
 * Convert a {@link LatLng} into a GeoJSON {@link Position}
 * @param latlng - the latlng to convert
 */
export function latlngToPosition(latlng) {
    return latlng.toReversed();
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGF0bG5nLmpzIiwic291cmNlUm9vdCI6InNyYy8iLCJzb3VyY2VzIjpbImxhdGxuZy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHQTs7O0dBR0c7QUFDSCxNQUFNLFVBQVUsYUFBYSxDQUM1QixLQUF3QztJQUV4QyxJQUFJLEtBQUssQ0FBQyxPQUFPLENBQUMsS0FBSyxDQUFDLEVBQUUsQ0FBQztRQUMxQixPQUFPLEtBQUssQ0FBQyxVQUFVLEVBQVksQ0FBQTtJQUNwQyxDQUFDO1NBQU0sSUFBSSxLQUFLLENBQUMsSUFBSSxLQUFLLE9BQU8sRUFBRSxDQUFDO1FBQ25DLE9BQU8sS0FBSyxDQUFDLFdBQVcsQ0FBQyxVQUFVLEVBQVksQ0FBQTtJQUNoRCxDQUFDO1NBQU0sQ0FBQztRQUNQLE9BQU8sS0FBSyxDQUFDLFFBQVEsQ0FBQyxXQUFXLENBQUMsVUFBVSxFQUFZLENBQUE7SUFDekQsQ0FBQztBQUNGLENBQUM7QUFFRDs7O0dBR0c7QUFDSCxNQUFNLFVBQVUsYUFBYSxDQUFDLE1BQWM7SUFDM0MsT0FBTyxFQUFFLElBQUksRUFBRSxPQUFPLEVBQUUsV0FBVyxFQUFFLE1BQU0sQ0FBQyxVQUFVLEVBQUUsRUFBRSxDQUFBO0FBQzNELENBQUM7QUFFRDs7O0dBR0c7QUFDSCxNQUFNLFVBQVUsZ0JBQWdCLENBQUMsTUFBYztJQUM5QyxPQUFPLE1BQU0sQ0FBQyxVQUFVLEVBQUUsQ0FBQTtBQUMzQixDQUFDIn0=